import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsReasonstudiosComponent } from './simple-icons-reasonstudios.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsReasonstudiosComponent ],
    exports:      [ SimpleIconsReasonstudiosComponent ],
    bootstrap:    []
})
export class SimpleIconsReasonstudiosModule {}
